// extracted by mini-css-extract-plugin
module.exports = {"content":"ScheduleTab_content__3QEBJ"};